import React from "react";
import logo from "../../assets/logo.png";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Header = styled.div`
  @media (min-width: 1024px) {
    padding-left: 123px;
  }
`;

export default () => (
  <Header className="pv2 ph3 bg-white bb b--near-white">
    <div className="columns is-multiline" style={{ transitionDelay: "300ms" }}>
      <div className="column is-9">
        <Link to="/">
          <img className="va" src={logo} height="35" width="35" alt="logo" />
          <span className="f4-ns f5 fw5 pl2 dark-blue ttc">
            DSA Recruitment Portal
          </span>
        </Link>
      </div>
    </div>
  </Header>
);



// WEBPACK FOOTER //
// ./src/components/common/Header.js